export const deactivateTour = (tour, tourKey) => {
  if (tourKey) {
    tour.deactivateTour(tourKey);
  } else {
    tour.deactivate();
  }
};